import CoverageIcon from '@mui/icons-material/PriceChangeOutlined';
import Container from '@mui/material/Container';

import SectionTitle from '@/components/SectionTitle/SectionTitle';
import usePageTitle from '@/hooks/usePageTitle';
import CoverageSection from '@/sections/Coverage';

const Coverage = () => {
  usePageTitle('Cotizador');

  return (
    <Container maxWidth="xxl">
      <SectionTitle title="Cotizador" mt={5}>
        <CoverageIcon fontSize="large" />
      </SectionTitle>
      <CoverageSection />
    </Container>
  );
};

export default Coverage;
